/**
 * Check if API response is JSON
 * @param res
 */
export function responseIsJson(res: Response) {
	return !!~(res.headers.get('content-type') || '').indexOf('application/json');
}
